import Vue from 'vue';
export default {
  setMemberPlanStatus: (state, payload) => state.memberPlanStatus = payload,
  setIsExceededStorage: (state, payload) => state.isExceededStorage = payload,
  setPlayerStatus: (state, payload) => state.playerStatus = payload,
  setPlayerConfig: (state, payload) => state.playerConfig = payload,
  setCurrentCourse: (state, payload) => state.currentCourse = payload,
  setCurrentModules: (state, payload) => state.currentModules = payload,
  setCurrentModule: (state, payload) => state.currentModule = payload,
  setCurrentModuleLessons: (state, payload) => state.currentModuleLessons = payload,
  setCurrentLesson: (state, payload) => state.currentLesson = payload,
  setCompletedCurrentLesson: (state, payload) =>state.currentLesson.is_completed = payload,
  setCompletedCurrentModuleLessons: (state, payload) => {
    state.currentModuleLessons.find(module => payload.id == module.id).is_completed = payload.completed;
  },
  setCountCurrentCourse: (state, payload) => {
    const course = state.currentCourse;    
    course.lessons_completed_count = course.lessons_completed_count + (payload);
    course.percentage_complete = (course.lessons_completed_count / course.lessons_count) * 100;    
  },
  setCountCurrentModules: (state, payload) => {
    const modules = state.currentModules;  
    modules.find(module => module.id == payload.id).lessons_completed_count += payload.value;
  },
  updateLessonRating: (state,{ rating }) => state.currentLesson.my_rating = rating,
  setResetCurrentLessonComments: (state, payload) => state.currentLessonComments = payload,
  setCurrentLessonComments: (state, payload) => {
    if (payload.length === 0) {
      return;
    }
    let comments = state.currentLessonComments;
    if (payload.parentId) {
      const parentComment = comments.find(comment => comment.id === payload.parentId);
      if (parentComment) {
        parentComment.replies = parentComment.replies || [];
        parentComment.replies.push(payload);
      }
    } else {
      comments = comments.concat(payload);
    }
    comments = comments.filter(
      (item, index, opt) =>
        index === opt.findIndex((t) => t.id === item.id)
    );
    comments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    state.currentLessonComments = comments
  },
  // 
  setLessonCommentsLoading: (state, payload) => state.lessonCommentsLoading = payload,
  setLessonCommentsCurrentPage: (state, payload) =>state.lessonCommentsCurrentPage = payload,
  setLessonCommentstotalPage: (state, payload) => state.lessonCommentstotalPage = payload,
  // 
  setNextLesson: (state, payload) => state.nextLesson = payload,
  setNextLessonForContinue: (state, payload) => state.nextLessonForContinue = payload,
  setPrevLesson: (state, payload) => state.prevLesson = payload,
  setPrevModule: (state, payload) => state.prevModule = payload,
  setNextModule: (state, payload) => state.nextModule = payload,
  setHasNextModule: (state, payload) => state.hasNextModule = payload,
  setHasNextLesson: (state, payload) => state.hasNextLesson = payload,
  setHasPrevLesson: (state, payload) => state.hasPrevLesson = payload,
  setHasPrevModule: (state, payload) => state.hasPrevModule = payload,
  setHasNextLessonForContinue: (state, payload) => state.setHasNextLessonForContinue = payload,
  setIsMobile: (state, payload) => state.isMobile = payload,
  setIsAutoplay: (state, payload) => state.isAutoplay = payload,
  updateLessonProgress(state, payload) {
    if (state.currentLesson && payload.percent !== undefined) {
      Vue.set(state.currentLesson, 'percent', payload.percent);
    }
  },
};
